var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 3.30536L9.83571 1.95V11.4536H0V3.30536ZM0 20.6946L9.83571 22.05V12.6643H0V20.6946V20.6946ZM10.9179 22.1946L24 24V12.6643H10.9179V22.1946V22.1946ZM10.9179 1.80536V11.4536H24V0L10.9179 1.80536V1.80536Z","fill":"black"}));
}

Windows.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
